module.exports = __webpack_public_path__ + "static/senseur-pluie-7782d08bfad1225eea864afdd05611f8.mp4";